export default __webpack_public_path__ + "static/avatar-892c0dd123519dac5ca12f14894df99c.jpg";